<template>
    <div class="group">
        <label for="country">Country</label>
        <select id="country" class="validation selectOptGroupCountry" v-bind:class="{ '-invalid': $parent.validation.country }" v-model="$parent.fields.country" @change="resetCountry">
            <option selected disabled value="">Choose One</option>
            <option value="United States">United States</option>
            <option value="Canada">Canada</option>
        </select>
        <div class="error-message" v-for="message in $parent.validation.country">{{ message }}</div>
    </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'country',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ],
        methods:{
            resetCountry(){
                this.$parent.validation.country = null;
                this.$parent.fields.state = (this.$parent.fields.state) ? '' : this.$parent.fields.state;
                //boolean (true for US, false otherwise)
                this.$parent.fields.marketing_consent = (this.$parent.fields.country === 'United States');
            }
        }
    }
</script>
